import { render, staticRenderFns } from "./CommunityFire.vue?vue&type=template&id=d536c0d0&scoped=true&"
import script from "./CommunityFire.vue?vue&type=script&lang=ts&"
export * from "./CommunityFire.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityFire.vue?vue&type=style&index=0&id=d536c0d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d536c0d0",
  null
  
)

component.options.__file = "CommunityFire.vue"
export default component.exports